// §3 guards — steps 3–8 redirect to the earliest incomplete step if opened
// directly. Draft is in-memory only, so a refresh sends the user back.
import type { ReactNode } from 'react';
import { Navigate } from 'react-router';
import { earliestIncompleteRoute, useOnboarding } from '@/context/OnboardingContext';

interface StepGuardProps {
  requires: (draft: ReturnType<typeof useOnboarding>['draft']) => boolean;
  children: ReactNode;
}

const StepGuard = ({ requires, children }: StepGuardProps) => {
  const { draft } = useOnboarding();
  if (!requires(draft)) {
    return <Navigate to={earliestIncompleteRoute(draft)} replace />;
  }
  return <>{children}</>;
};

export default StepGuard;
